import logo from "./images/logo.png";
import "./App.css";

function App() {
  return (
    <div className="landing-page">
      {/* Blue gradient blobs */}
      <div className="gradient-blob top-right"></div>
      <div className="gradient-blob bottom-left"></div>

      {/* Header */}
      <header className="header">
        <div className="logo-section">
          <img src={logo} alt="C1oser Inc" className="logo" />
        </div>
        <a
          href="https://www.loom.com/share/6b8e2fac517d4d8d83f476cd6e076747"
          target="_blank"
          rel="noopener noreferrer"
          className="demo-link"
        >
          See Demo
        </a>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <h2 className="welcome-text">Welcome to AI-Powered Transactions.</h2>
        <h1 className="hero-title">C1OSER</h1>

        <div className="cta-buttons">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSf5RNDIgPErmubbPT7n2rJU1hXcMdQWOVp57xFEmwI43gfzKQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn"
          >
            For Brokers
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSf_FwaBunJ2DuIutA4vu0F3r46k5mAoWfjifjk7KJpYKu7T-w/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn cta-btn-blue"
          >
            For Agents
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L12 5M19 12L12 19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="copyright">© C1oser 2025</footer>
    </div>
  );
}

export default App;
